module.exports = __webpack_public_path__ + "static/media/intro-series.1e64bd5a.png";